import Button, { Theme } from "theme/components/buttons/Button";

import React from "react";
import colors from "theme/config/colors";

const BlackSolidButton = (props: any) => {
    const theme: Theme = {
        color: colors.white,
        backgroundColor: colors.black,
        borderColor: colors.black,
        hover: {
            backgroundColor: colors.neutral_700,
            borderColor: colors.neutral_700,
        },
        active: {
            backgroundColor: colors.neutral_800,
            borderColor: colors.neutral_800,
        },
        selected: {
            backgroundColor: colors.blue_700,
            borderColor: colors.blue_700,
        },
        disabled: {
            color: colors.neutral_500,
            backgroundColor: colors.blue_700, // or neutral_400 without opacity?
            borderColor: colors.blue_700,
            opacity: "30%",
        },
    };

    return <Button {...props} theme={theme} />;
};

export default BlackSolidButton;
